module.exports = __webpack_public_path__ + "static/images/step.9Nyn-Cr.svg";